import { useEffect, useState } from 'react'
import { getServiceStatus, ServiceStatus } from '../helpers/api'
import { getErrorMessage } from '../helpers/error'
import { logError } from '../helpers/datadog'

export const useServiceStatus = () => {
  const [serviceStatus, setServiceStatus] = useState<ServiceStatus | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const response = await getServiceStatus()
        setServiceStatus(response.data.status)
      } catch (e) {
        logError('Failed to fetch service status', { error: getErrorMessage(e) })
        setError(true)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [])

  return { serviceStatus, isLoading, error }
}
